/* eslint-disable no-use-before-define */
import {css} from '@emotion/core'

export const listCss = css `
    div {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    dl {
        display: flex;
        flex-direction: row;
    }
    dt, dd {
        line-height: 1.4;
        font-weight:400;
        color: #242424;
        border-bottom: 1px solid #e4e4e4;
        padding: 6px 3px 6px 0px;        
    }
    dt {
        flex-basis: fit-content;
        flex-grow: 1;
        text-align: left;
    }
    dd {
        flex-basis: auto;
        flex-grow: 2;
        text-align: right;
        font-weight: 500;
        white-space: nowrap;
    }
`




// WEBPACK FOOTER //
// ./src/orders/modal/style.js